import * as React from "react";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import ProTip from "./ProTip";
import { all, intro } from "./helper/client";
import IntroContainer from "./components/intro/intro.container";
import CanvaContainer from "./components/canva/canva.container";

declare const window: any;

export default function App() {
  const [dataIntro, setDataIntro] = React.useState({});
  const [data, setData]: any = React.useState({});
  const [isPortrait, setIsPortrait] = React.useState(false);
  const [introFrame, setIntroFrame] = React.useState("");
  const [progress, setProgress] = React.useState(0);
  const [introView, setIntroView] = React.useState(true);
  const [isTheme, setIsTheme] = React.useState("Glass");
  const [counter, setCounter] = React.useState(0);
  const [imageDivs, setImageDivs] = React.useState(
    Array.from({ length: 100 }, () => null)
  );

  const [imagesLoaded, setImagesLoaded] = React.useState(false);
  const [fourthPositionLoaded, setFourthPositionLoaded] = React.useState(false);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setCounter((prevCounter) => {
        if (imagesLoaded) {
          clearInterval(timer);
          setProgress(100);
          return 180;
        } else if (
          prevCounter < 170 ||
          (prevCounter < 180 && fourthPositionLoaded)
        ) {
          return prevCounter + 1;
        } else {
          clearInterval(timer);
          return prevCounter;
        }
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [imagesLoaded, fourthPositionLoaded]);

  /* React.useEffect(() => {
    const currentProgress = ((counter / 180) * 100).toFixed(2);
    setProgress(parseFloat(currentProgress));
  }, [counter]); */

  React.useLayoutEffect(() => {
    const fetchData = async () => {
      try {
        let dataIntro = await intro();
        let data = await all();

        let dataJsonIntro = dataIntro.data;
        const head = document.querySelector("head");

        const addFavicon = (
          rel: string,
          href: string,
          type?: string,
          sizes?: string
        ) => {
          const link: any = document.createElement("link");
          link.rel = rel;
          link.href =
            (window.hybrid
              ? ""
              : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") +
            href +
            "?v=" +
            new Date().getTime();
          if (type) link.type = type;
          if (sizes) link.sizes = sizes;
          head?.appendChild(link);
        };

        if (dataJsonIntro.project.favicon) {
          addFavicon(
            "icon",
            dataJsonIntro.project.faviconPNG,
            "image/png",
            "16x16"
          );
          addFavicon(
            "icon",
            dataJsonIntro.project.faviconPNG,
            "image/png",
            "32x32"
          );
          addFavicon(
            "icon",
            dataJsonIntro.project.faviconPNG,
            "image/png",
            "96x96"
          );
          addFavicon("shortcut icon", dataJsonIntro.project.favicon);

          addFavicon(
            "mask-icon",
            dataJsonIntro.project.faviconSVG,
            "image/svg+xml"
          );
        }

        if (dataJsonIntro.project.faviconPNG) {
          addFavicon(
            "apple-touch-icon",
            dataJsonIntro.project.faviconPNG,
            "image/png",
            "180x180"
          );
        }

        document.title = `${dataJsonIntro.project.nombre_proyecto}`;

        setDataIntro(dataJsonIntro.project);

        let dataJson = data.data;
        setData(dataJson.project);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  React.useEffect(() => {
    if (Object.keys(data).length > 0) {
      let preloadImages: any = [];
      let preloadImagesPlus: any = [];
      if (window.innerHeight > window.innerWidth) {
        preloadImages = data.spin.filter(
          (objeto) => objeto.type === "General portrait"
        )[0];
        data.spin.forEach((element) => {
          if (element.type.includes("portrait")) {
            preloadImagesPlus.unshift(element.files[0]);
          }
        });
      } else {
        preloadImages = data.spin.filter(
          (objeto) => objeto.type === "General landscape"
        )[0];
        data.spin.forEach((element) => {
          if (element.type.includes("landscape")) {
            preloadImagesPlus.unshift(element.files[0]);
          }
        });
      }

      const X = [0, 4, 2, 8, 1, 3, 6, 5, 9, 7];
      let counter = 0;
      const loadImage = (src: string, value: number): Promise<void> => {
        return new Promise((resolve) => {
          const image = new Image();
          image.src = src;
          image.onload = () => {
            counter++;
            setProgress(counter * 2);
            /* if (counter === preloadImages.files.length) {
              setImagesLoaded(true);
              setProgress(100);
            } */
            resolve();
          };
        });
      };
      const loadImagePlus = (): Promise<void> => {
        return new Promise((resolve) => {
          preloadImagesPlus.forEach((src) => {
            const image = new Image();
            image.src =
            (window.hybrid
              ? ""
              : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") +
              src.replace(/ /g, "%20");
            image.onload = () => {
              resolve();
            };
          });
        });
      };

      const preloadImagesSequentially = async () => {
        let fourthPositionCounter = 0;

        await loadImagePlus();
        for (let i = 0; i < X.length; i++) {
          const x = X[i];
          for (let n = 0; n <= 9; n++) {
            const value = x + n * 10;
            const src =
              (window.hybrid
                ? ""
                : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") +
              preloadImages.files[value].replace(/ /g, "%20");
            await loadImage(src, value);

            if (i === 3) {
              // i === 3 es la cuarta posición de X
              fourthPositionCounter++;
              if (fourthPositionCounter >= 10) {
                setFourthPositionLoaded(true);
              }
            }
          }
        }
      };

      preloadImagesSequentially();
    }
  }, [data]);

  //console.log(progress, counter);

  return (
    <div className="full-container-app">
      <IntroContainer
        intro={dataIntro}
        progress={Math.round(progress)}
        setIntroView={setIntroView}
        introView={introView}
        isTheme={isTheme}
        isPortrait={window.functionIsPortrait()}
        counter={counter}
      />
      {progress >= 100 || (progress >= 80 && counter >= 180) ? (
        <CanvaContainer
          data={data}
          introView={introView}
          isTheme={isTheme}
          setIsTheme={setIsTheme}
          imageDivs={imageDivs}
        />
      ) : (
        <></>
      )}
    </div>
  );
}
